<!-- Hlavička stránky podle gov.cz (vzor AISK): nadpis h1 nad kartou, akce stránky vpravo -->
<div class="flex flex-wrap items-end justify-between gap-4 mt-4 mb-6">
  <div class="flex items-center max-lg:min-w-0">
    @if (backRouterLink) {
      <a
        class="flex shrink-0 items-center justify-center size-10 mr-3 -ml-2 p-0 rounded-full bg-transparent text-(--text-primary) text-(length:--font-size-body-xl) cursor-pointer [transition:color_0.3s_ease,background-color_0.3s_ease] hover:bg-(--background-primary-subtle) hover:text-(--text-primary-color) focus-visible:outline-2 focus-visible:outline-(--border-primary) focus-visible:outline-offset-2"
        [pTooltip]="backRouterLinkTooltip() ?? 'Zpět'"
        tooltipStyleClass="back-tooltip"
        [routerLink]="useHistoryBackRouterLink() ? (backLinkCompleteUrl.url ?? backRouterLink) : backRouterLink"
        [queryParams]="backLinkCompleteUrl.queryParams || null"
        [queryParamsHandling]="queryParamsHandling()"
        aria-label="Zpět">
        <i class="pi pi-chevron-left" aria-hidden="true"></i>
      </a>
    }
    @if (pageTitle) {
      <h1
        [pTooltip]="pageTitleTooltip() ?? ''"
        class="m-0 wrap-break-word max-lg:wrap-anywhere flex items-center gap-1"
        [attr.data-cy]="dataCy()">
        {{ pageTitle }}
        @if (pageTitleSuffix) {
          <span class="text-(--text-status-error)">
            {{ pageTitleSuffix }}
          </span>
        }
        @if (label) {
          <span
            class="ml-1 py-1 px-2 rounded-(--corner-radius-2xl) bg-(color:--background-primary) text-(--text-white-fixed) text-(length:--font-size-body-s)">
            {{ label }}
          </span>
        }
      </h1>
    }
  </div>
  <div class="flex justify-end gap-2 empty:hidden">
    <ng-content select="[actions]"></ng-content>
  </div>
</div>

<!-- Karta obsahu: bílá, zaoblená, bez stínu (.reza-card v components.css knihovny) -->
<div class="reza-card">
  @if (pageSubtitle) {
    <p class="subtitle mt-0 mb-4 mx-0">{{ pageSubtitle }}</p>
  }
  <ng-content></ng-content>
</div>
